import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Input, Slider as SliderAntd } from 'antd'
import 'antd/dist/antd.css'

const Slider = ({
    name,
    actionFrom,
    actionTo,
    actionResetFrom,
    actionResetTo,
    data,
    from,
    to,
    min,
    max
}) => {
    const dispatch = useDispatch()

    // Если значение равно минимальному, то это равносильно установке
    // первоначального состояния в фильтре, но для цены это не работает, т.к.
    // цена зависит от валюты и ее перв. состояние 0 (а не минимальное, т.к. оно разное
    // для разны валют), поэтому для работы isFilterApplied, где мы сравниваем текущее состояние и первоначальеое,
    // применяем этот хак, где вместо установки значения применяем его сброс.
    // Это не ломает логику для други фильтров, например, для к-ва, но фиксит цену как нужно.
    const setPriceFrom = (e) => {
        const value = Number(e.target.value)

        if (value === min) {
            dispatch(actionResetFrom())
        } else {
            dispatch(actionFrom(value))
        }
    }
    const setPriceTo = (e) => {
        const value = Number(e.target.value)

        if (value === max) {
            dispatch(actionResetTo())
        } else {
            dispatch(actionTo(value))
        }
    }

    const onAfterChange = (value) => {
        const from = Number(value[0])
        const to = Number(value[1])

        if (from === min) {
            dispatch(actionResetFrom())
        } else {
            dispatch(actionFrom(from))
        }

        if (to === max) {
            dispatch(actionResetTo())
        } else {
            dispatch(actionTo(to))
        }
    }

    // Была проблема - после сброса фильтра (resetPriceFromRUB) слайдер не менял свое значение
    // Если записать в value (58 строке ниже) слайдера [from, to], то он перестает двигаться,
    // оно и понятно, т.к. заначение там должно динамически меняться по ходу движения слайдера
    // чтобы это починить пришлось ввести состояние тут через useState и передавать его в value
    // это решение нашел тут https://github.com/react-component/slider/issues/366#issuecomment-351044034 (хотя
    // там вообще не про эту библиотеку вроде, хотя оч похоже)
    // После этого слайдер динамически заработал при прописанном value={value}, но слайдер
    // все равное не менялся после сброса (resetPriceFromRUB), для этого пришлось добавить useEffect,
    // который срабатывает после (resetPriceFromRUB), что нам и нужно, но также он срабатывает и после
    // onAfterChange, что не нужно, но вроде не критично
    //
    // Если найдешь какое-то более оптимальное решение, то напиши, плиз как сделаешь - гляну. Пока
    // оставляю так, может позде сам что еще придумаю.
    // Также я думал в сторону defaultValue, но оно похоже только при самой первой отрировке используется и никак
    // не задействуется после сброса фильтра (resetPriceFromRUB).
    const [value, setValue] = useState([from, to])

    const onChange = (value) => {
        setValue(value)
    }

    useEffect(() => {
        setValue([from, to])
    }, [from, to])

    return (
        <div className="search-filter__prop">
            <div>{name}</div>
            <div className="slider-inputs">
                <Input className="slider-input" value={from} onChange={setPriceFrom} /> -
                <Input className="slider-input" value={to} onChange={setPriceTo} />
            </div>
            <div className="slider-range">
                <SliderAntd
                    range={true}
                    value={value}
                    step={1}
                    defaultValue={[from, to]}
                    min={min}
                    max={max}
                    onChange={onChange}
                    onAfterChange={onAfterChange}
                />
            </div>
        </div>
    )
}

export default Slider
